export const getIncidentAddress = (location) => {
  if (!location) {
    return '-';
  }

  const parts = [
    location.unit_value,
    location.street,
    location.street_postfix_modifier,
    location.postal_community,
    location.state,
    location.postal_code,
  ].filter(Boolean);

  return parts.join(', ') || '-';
};

export const getIncidentStatus = (incident) => {
  const unitResponses = incident.unit_responses;
  if (!unitResponses || unitResponses?.length === 0) return 'Pending';

  const allClear = unitResponses.every((unit) => unit.unit_clear);
  if (allClear) return 'Closed';

  const anyOnScene = unitResponses.some((unit) => unit.on_scene);
  if (anyOnScene) return 'In Progress';

  const anyDispatched = unitResponses.some((unit) => unit.dispatch);
  if (anyDispatched) return 'Dispatched';

  return 'Pending';
};

export const earliestUnit = (unitResponses) => {
  if (!!unitResponses) {
    const fltering = unitResponses.filter((unit) => !!unit.on_scene);

    return fltering?.length > 0
      ? fltering.reduce((min, unit) =>
          new Date(unit.on_scene) < new Date(min.on_scene) ? unit : min
        ).reported_unit_id
      : '-';
  } else return '-';
};

export const additionalUnits = (unitResponses) => {
  if (!!unitResponses) {
    return unitResponses
      .filter((item) => item.reported_unit_id !== earliestUnit(unitResponses))
      ?.map((item) => item.reported_unit_id)
      .join(', ');
  } else return '-';
};
